import { useEffect, useState } from "react";
import { NotificationsIcon } from "../../../../components/icon/icons";
import { selectNotificationCount } from "../../../../redux/selectors/notifications";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotifications,
  toggleNotifcationPanel,
} from "../../../../redux/actions/notificationsActions";
import { ItemWrapper, Wrapper } from "./notification-button.styles";

const NotificationButton = () => {
  const dispatch = useDispatch();
  const count = useSelector(selectNotificationCount);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let noticeInterval: NodeJS.Timeout;
    const effect = async () => {
      dispatch(getNotifications());
    };

    // @ts-ignore
    if (!noticeInterval) {
      noticeInterval = setInterval(() => {
        effect();
      }, 60000);
    }

    if (!loaded) {
      effect();
      setLoaded(true);
    }
    return () => clearInterval(noticeInterval);
  }, [dispatch, loaded]);

  const clickButton = () => {
    dispatch(toggleNotifcationPanel());
  };

  return (
    <Wrapper onClick={clickButton} title={"Notification menu with " + ((count as number) > 0 ? ((count as number) > 1 ? count +" notifications" : "1 notification") : "no notifications")}>
      <NotificationsIcon />
      {(count as number) > 0 ? <ItemWrapper aria-hidden="true">{count}</ItemWrapper> : null}
    </Wrapper>
  );
};

export default NotificationButton;
